import type { FC } from 'react';
import clsx from 'clsx';

import Button from '@trend-dev/trendtech-ui/components/UI/Button';
import { Icon } from '@trend-dev/ui-libs-icons';

import styles from './styles.module.scss';

const AccessGrantedButton: FC = () => {
    return (
        <Button kind='color_green' square onlyIcon size='sm' borderRadius='full' className={clsx(styles.icon, styles.iconGranted)}>
            <Icon name='Check_20' />
        </Button>
    );
};

export default AccessGrantedButton;
